// extracted by mini-css-extract-plugin
export var addButton = "_e7-0";
export var border = "_e7-8";
export var check = "_e7-h";
export var danger = "_e7-6";
export var dropdownContainer = "_e7-1";
export var editModalBody = "_e7-j";
export var footerContainer = "_e7-i";
export var fullWidth = "_e7-a";
export var hide = "_e7-9";
export var icon = "_e7-3";
export var input = "_e7-7";
export var inputFlex = "_e7-b";
export var inputWrapper = "_e7-c";
export var manualFocus = "_e7-5";
export var optionButton = "_e7-4";
export var pillWrapper = "_e7-e";
export var pointer = "_e7-2";
export var showOverflow = "_e7-f";
export var tagsFlex = "_e7-d";
export var xButton = "_e7-g";